module.exports = __webpack_public_path__ + "media/images/athletes/539-c0cccb3090ecdb1549eb7bee102af674.png";